/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260521
*/

'use strict';

import {
    addDays
} from './ctssDateTime.js';
import {
    getTableRows} from './ctssHtml.js';
import {
    deleteImgFromCloudAsync,
    hasImgsToDelete,
    hasImgsToUpload,
    setHasImgsToDelete,
    setHasImgsToUpload,
    uploadImgToCloudAsync,
    uploadToImgCtrl
} from './ctssImg.js';

import {
    allSettled,
    deletePromise,
    getPromise,
    initDragDropTableSort,
    savePromise
} from './ctssJQuery.js';
import {
    isDataModified,
    missingRequiredData,
    phoneNumberInputMask,
    setModified,
    validEmail,
    validURL
} from './ctssVal.js';
import {
    initGroupCtrlsAsync,
    initGroupsDDL
} from './snGroupCtrls.js'
import {
    initGroupsAsync
} from './snGroups.js'
import {
    getSettingsAsync
} from './snSettings.js';
import {
    appDebugMode,
    getAppToken,
    getImgsBaseURLAsync,
    getTestFolderParams,
    Features,
    ImgsFolder,
    setMenu
} from './snSite.js';

const { useTestFolder, testFolderParam } = getTestFolderParams();

const token = getAppToken();

const addAnnouncement = () => {

    const dt = new Date(),
        gid = hasGroups ? parseInt($('#hiddenGroupID').val(), 10) : 0,
        postUntil = addDays(dt, 30);

    announcement = {
        id: "-1",
        gid: gid,
        mg: mg,
        by: by,
        byImgNm: byImgNm,
        hasNotif: true,
        notifID: "",
        pCode: 0,
        dtPublished: dt,
        postUntil: postUntil,
        isPinned: false,
        pOdr: 0
    };
    $('#updateDlg input, #updateDlg textarea').val('');
    $('#imgAnnouncement').attr('src', '');
    $('#dtPostUntil').kendoDatePicker({ value: postUntil, min: dt });
    setUpdateDlgFooter({ pCode: 0, dtPublished: dt });
}

const clearImg = () => {
    if (hasImgsToUpload()) {
        setHasImgsToUpload(false);
    } else {
        clearedImgNm = announcement.imgNm;
        announcement.imgNm = '';
        $('#hiddenImgNm').val('');
        setHasImgsToDelete(true);
    }
    $('#imgAnnouncement').attr('src', '');
}

const copyTextToNotif = () => {
    const s = $('#editText').val();
    $('#editNotif').val(s.length > 255 ? s.substr(0, 255) : s);
}

const deleteAnnouncementAsync = async (params) => {

    const idx = announcements.findIndex(x => x.id === params.key);
    const imgNm = announcements[idx].imgNm === null ? '' : announcements[idx].imgNm;

    const p = {
        url: `Announcements/${token.CG}/${params.key}/${hasComments}/${imgNm}`,
        divErrMsg: 'divDelDlgErrMsg'
    };

    await deletePromise(p)
        .then(() => {
            $('#deleteDlg').modal('hide');
            /* Just removing from page is faster than going to server to refresh */
            announcements.splice(announcements.findIndex(x => x.id === params.key), 1);
            $('#' + params.key).remove();
        });
}

const getAnnouncementAsync = async (params) =>
    await getPromise({ url: `Announcements/${token.CG}/${params.id}` });

const getAnnouncementsDataAsync = async () => {

    /* No pagination for website */
    let qryParams;
    if (!groupsQueryParam) {
        qryParams = '?pagination=false'
    }                 
    else {
        qryParams = groupsQueryParam + '&pagination=false';
    }
    return await getPromise({ url: `Announcements/${token.CG}/AdminMenu${qryParams}` });
}

const getAnnouncementRow = (params = {}) => {
    if (!params.data) {
        alert('params.data is a required parameter for getAnnouncementRow')
        return;
    }

    const {
        datePublished,
        gid,
        id,
        isPinned,
        publishCode,
        title
    } = params.data

    let row = '';
    if (!draftHdr && publishCode === 0) {
        row += '<tr><td colspan="4" class="col-md-12 grpHdr">Draft Accouncements</td></tr>';
        draftHdr = true;
    } else if (!scheduledHdr && publishCode === 1) {
        row += '<tr><td colspan="4" class="col-md-12 grpHdr">Scheduled Announcements</td></tr>';
        scheduledHdr = true;
    } else if (!publishedHdr && publishCode === 2) {
        row += '<tr><td colspan="4" class="col-md-12 grpHdr">Published Announcements</td></tr>';
        publishedHdr = true;
    };
    const g = groups.find(x => x.value === gid.toString());
    if (g != undefined) {

        row += `<tr id="${id}" >` +
            `<td class="col-md-1 imgDesc-circle-sm" style="padding-left: 10px;"><img src="${g.imgSrc}"></td>` +
            `<td class="col-md-7">${title}</td>`;
    } else {
        row += `<tr id="${id}" >` +
            `<td class="col-md-1"> </td><td class="col-md-7">${title}</td>`;
    }
    row += publishCode === 0
        ? '<td class="col-md-2"></td>'
        : '<td class="col-md-2 text-right">' + new Date(datePublished).toLocaleDateString() + '</td>';

    row += '<td class="col-md-2 text-right">';
    if (publishCode === 2) {
        row += isPinned
            ? `<span id="pin${id}" class="fa fa-thumb-tack faAppColor mRight10" title="pin..."></span>`
            : `<span id="pin${id}" class="fa fa-thumb-tack fa- fa-rotate-90 mRight10" title="pin..."></span>`;
    }
    row += '<span class="fa fa-pencil mRight10" title="Edit announcement..." data-toggle="modal" data-target="#updateDlg" ' +
        `data-key="${id}" data-group_id="${gid}"></span>` +
        `<span class="fa fa-trash" title="Delete announcement..." data-toggle="modal" data-target="#deleteDlg" data-key="${id}"></span>` +
        '</td></tr>';
    return row;
}

const getAnnouncementTitle = (params) =>
    announcements[announcements.findIndex(x => x.id === params.id)].title;

const getNoGroupsAnnouncementRow = (params = {}) => {
    if (!params.data) {
        alert('params.data is a required parameter for getAnnouncementRow')
        return;
    }

    const {
        datePublished,
        id,
        isPinned,
        publishCode,
        title
    } = params.data

    let row = '';
    if (!draftHdr && publishCode === 0) {
        row += '<tr><td colspan="3" class="col-md-12 grpHdr">Draft Accouncements</td></tr>';
        draftHdr = true;
    } else if (!scheduledHdr && publishCode === 1) {
        row += '<tr><td colspan="3" class="col-md-12 grpHdr">Scheduled Announcements</td></tr>';
        scheduledHdr = true;
    } else if (!publishedHdr && publishCode === 2) {
        row += '<tr><td colspan="3" class="col-md-12 grpHdr">Published Announcements</td></tr>';
        publishedHdr = true;
    };
    row += `<tr id="${id}" ><td class="col-md-8">${title}</td>`;
    row += publishCode === 0
        ? '<td class="col-md-2"></td>'
        : '<td class="col-md-2 text-right">' + new Date(datePublished).toLocaleDateString() + '</td>';

    row += '<td class="col-md-2 text-right">';
    if (publishCode === 2) {
        row += isPinned
            ? `<span id="pin${id}" class="fa fa-thumb-tack faAppColor mRight10" title="pin..."></span>`
            : `<span id="pin${id}" class="fa fa-thumb-tack fa- fa-rotate-90 mRight10" title="pin..."></span>`;
    }
    row += `<span class="fa fa-pencil mRight10" title="Edit announcement..." data-toggle="modal" data-target="#updateDlg" data-key="${id}"></span>` +
        `<span class="fa fa-trash" title="Delete announcement..." data-toggle="modal" data-target="#deleteDlg" data-key="${id}"></span>` +
        '</td></tr>';
    return row;
} 

const initAnnouncementsGrid = () => {
    let content;
    if (hasGroups) {
        content = '<tr>' +
            '<th class="col-md-1">Group</th>' +
            '<th class="col-md-7">Announcement</th>' +
            '<th class="col-md-2">Published On</th>' +
            '<th class="col-md-2">' +
            '    <div class="pull-right">' +
            '        <button id="btnAddAnnouncement" class="btn btn-sm"' +
            '                data-toggle="modal" data-target="#updateDlg" data-key="-1">' +
            '            <span class="fa fa-plus"></span> Add Announcement' +
            '        </button>' +
            '    </div>' +
            '</th>'
        '</tr>';
    }
    else {
        content = '<tr>' +
            '<th class="col-md-8">Announcement</th>' +
            '<th class="col-md-2">Published On</th>' +
            '<th class="col-md-2">' +
            '    <div class="pull-right">' +
            '        <button id="btnAddAnnouncement" class="btn btn-sm"' +
            '                data-toggle="modal" data-target="#updateDlg" data-key="-1">' +
            '            <span class="fa fa-plus"></span> Add Announcement' +
            '        </button>' +
            '    </div>' +
            '</th>'
        '</tr>';
    }
    $('#gridAnnouncements thead').html(content);
}

const initConfirmDlg = () => {
    $('#confirmDlg').on('show.bs.modal', (e) => {
        const caller = e.relatedTarget === undefined
            ? $('#confirmDlg').attr('data-caller') /* when data-caller is set in javascript instead of html */
            : e.relatedTarget.dataset.caller;
        if (caller === 'btnPublish') {
            $('#confirmPrompt').text('Are you sure you publish this announcement?');
        } else if (caller === 'btnCopyAnnouncement') {
            $('#confirmPrompt').text('Are you sure want to overrite the existing notification message?');
        } else if (caller === 'btnClearImg') {
            $('#confirmPrompt').text('Are you sure want to clear this image?');
        }
        $('#btnConfirm').off('click').click(async () => {
            if (caller === 'btnPublish') {
                announcement.pCode = 2;
                await saveAnnouncementDlgDataAsync({ btnid: '#btnConfirm', caller: 'btnConfirm' });
            } else if (caller === "btnCopyAnnouncement") {
                copyTextToNotif();
                $('#confirmDlg').modal('hide');
            } else if (caller === "btnClearImg") {
                clearImg();
                $('#confirmDlg').modal('hide');
            }
        });
    });
}
const initDeleteDlg = () => {
    $('#deleteDlg').on('show.bs.modal', (e) => {
        const key = e.relatedTarget.dataset.key;
        $('#deletePrompt').text(`Are you sure you want to delete the ${getAnnouncementTitle({ id: key })} announcement?`);
        $('#btnDelete').off('click').click(() => deleteAnnouncementAsync({ key: key }));
    });
}

const initScheduleDlg = () => {
    $('#scheduleDlg').on('show.bs.modal', () => {
        $('#divSchDlgErrMsg').addClass('hidden');
        // Equality comparisions of dates require comparing time to work...
        const origDt = new Date();
        $('#dtSchedule').kendoDateTimePicker({ value: origDt, min: origDt });

        $('#btnSchedule').off('click').click(async () => {
            const newDt = new Date($('#dtSchedule').val()).toUTCString();
            if (newDt < origDt) {
                $('#divSchDlgErrMsg').text(`Date scheduled cannot be earlier than ${origDt.toLocaleDateString()} ${origDt.toLocaleTimeString()}.`).removeClass('hidden');
            } else {
                announcement.dtPublished = new Date($('#dtSchedule').val()).toUTCString();
                announcement.pCode = 1;
                $('#scheduleDlg').modal('hide');
                await saveAnnouncementDlgDataAsync({ btnid: '#btnSchedule' });
            }
        });
    });
}

const initUpdateDlg = () => {

    $('#editPhone').on('input', phoneNumberInputMask());

    $('.accordion').click(function () {
        const icon = $($(this).find('span'))[0];
        $(icon).toggleClass('fa-plus-circle').toggleClass('fa-minus-circle');
        $(this).next('div').toggleClass('hidden');
    });

    $('#btnCopyAnnouncement').on('click', () => {
        if ($('#editNotif').val().length > 0) {
            $('#confirmDlg')
                .attr('data-caller', 'btnCopyAnnouncement')
                .modal('show');
        } else {
            copyTextToNotif();
        }
    });

    $('.cancelChanges').on('click', () => {
        $('#divUpdDlgErrMsg').addClass('hidden');
        document.getElementById("loader").style.display = "none";
    });
    $('#btnSave').on('click').click(async () => await saveAnnouncementDlgDataAsync({ btnid: '#btnSave' }));

    $('#updateDlg').on('show.bs.modal', async (e) => {

        /* Clear image control that may have been filled on previous showing */
        $('#imgAnnouncement').attr('src', '');

        if (hasGroups) {
            /* Initialize the model group DDL to the Group Toolbar DDL value */
            initGroupsDDL({
                groupID: $('#hiddenToolBarGroupID').val(),
                groups
            })
        } else {
            $('#groupInfo').addClass('hidden');
        }
        const key = (e.relatedTarget === undefined) ? "-1" : e.relatedTarget.dataset.key;
        if (key !== "-1") {
            try {
                announcement = await getAnnouncementAsync({ id: key });
                refreshUpdateDlg();
                $('#updateDlgLbl').text(`Editing ${getAnnouncementTitle({ id: key })} information...`);
            }
            catch (error) { }
        } else {
            addAnnouncement();
            $('#updateDlgLbl').text('Adding an announcement...');
        }
    });

    $('#editAnnouncementImg').on('change',
        () => {
            uploadToImgCtrl({
                inputFileCtrl: '#editAnnouncementImg',
                imgCtrl: '#imgAnnouncement',
                divErrMsg: '#divUpdDlgErrMsg'
            })
        });
}

const refreshAnnouncementsGrid = () => {
    draftHdr = false;
    scheduledHdr = false;
    publishedHdr = false;
    if (hasGroups) {
        getTableRows({ arr: announcements, fnGetRow: getAnnouncementRow, gridNm: 'gridAnnouncements' });
    }
    else {
        getTableRows({ arr: announcements, fnGetRow: getNoGroupsAnnouncementRow, gridNm: 'gridAnnouncements' });
    }
    $('.fa-thumb-tack').on('click', async (e) => {

        const $span = $(e.target);
        const id = $span[0].id.substr(3); // remove pin prefix

        const a = await getAnnouncementAsync({ id: id });

        if (a.isPinned) {
            $span.addClass('fa-rotate-90');
            a.pOdr = 255;
        }
        else {
            $span.removeClass('fa-rotate-90');
            const minPinnedOrder = announcements.reduce((min, e) => e.pinnedOrder < min ? e.pinnedOrder : min, announcements[0].pinnedOrder - 1);
            a.pOdr = minPinnedOrder;
        }

        a.isPinned = !a.isPinned;

        await saveAnnouncementAsync({ data: a });
    });
}

const refreshUpdateDlg = () => {

    $('#editTitle').val(announcement.title);
    $('#dtPostUntil').kendoDatePicker({ value: new Date(announcement.postUntil), min: new Date() });
    $('#editText').val(announcement.text);
    $('#editNotif').val(announcement.notif);
    $('#hiddenImgNm').val(announcement.imgNm);
    if (announcement.imgNm.length > 0) {
        $('#imgAnnouncement').prop('src', announcementImgsBaseURL + announcement.imgNm);
    }
    $('#editActionURL').val(announcement.actionURL);
    $('#editEmail').val(announcement.email);
    $('#editPhone').val(announcement.phone);
    setUpdateDlgFooter({
        pCode: announcement.pCode,
        dtPublished: new Date(announcement.dtPublished)
    });
}

/* Saves announcement using data from the update dialog */
const saveAnnouncementDlgDataAsync = async (params) => {

    const saveDataAsync = async () => {
        //console.log('hiddenGroupID', $('#hiddenGroupID').val());
        //console.log('gid', hasGroups ? parseInt($('#hiddenGroupID').val(), 10) : 0);

        const data = {
            gid: hasGroups ? parseInt($('#hiddenGroupID').val(), 10) : 0,
            mg: announcement.mg,
            by: announcement.by,
            byImgNm: announcement.byImgNm,
            title: $('#editTitle').val(),
            hasNotif: announcement.hasNotif,
            notifID: announcement.notifID,
            notif: $('#editNotif').val(),
            text: $('#editText').val(),
            imgNm: $('#hiddenImgNm').val(),
            actionURL: actionURL,
            email: email,
            phone: $('#editPhone').val(),
            pCode: announcement.pCode,
            dtPublished: announcement.dtPublished,
            postUntil: $('#dtPostUntil').val(),
            isPinned: announcement.isPinned,
            pOdr: announcement.pOdr
        };
        if (announcement.id !== "-1") {
            data.id = announcement.id;
        }

        if (isNaN(data.gid)) {
            data.gid = 0;
        }

        await saveAnnouncementAsync({
            data: data,
            divErrMsg: 'divUpdDlgErrMsg'
        })
            .then(async () => {
                try {
                    announcements = await getAnnouncementsDataAsync();
                    refreshAnnouncementsGrid();
                    $('#updateDlg').modal('hide');
                }
                catch (error) { }
            });
    }

    if (params.caller !== undefined && params.caller === 'btnConfirm') {
        $('#confirmDlg').modal('hide');
    }

    const dataItems = [
        { ctrlNm: '#editTitle', labelText: 'Title' },
        { ctrlNm: '#editText', labelText: 'Announcement' },
        { ctrlNm: '#editNotif', labelText: 'Notification Msg' }
    ];

    if (missingRequiredData({
        errMsgid: 'divUpdDlgErrMsg',
        dataItems: dataItems
    })) return;

    const actionURL = $('#editActionURL').val();
    const email = $('#editEmail').val();
    if (actionURL.length > 0 && !validURL({ url: actionURL })) {
        $("#divUpdDlgErrMsg").text("Please enter a properly formatted url.").removeClass('hidden');
        return;
    }
    if (email.length > 0 && !validEmail({ email })) {
        $("#divUpdDlgErrMsg").text("Please enter a properly formatted email address.").removeClass('hidden');
        return;
    }
    if (hasImgsToDelete() || hasImgsToUpload()) {
        const imgPromises = [];
        if (hasImgsToDelete() && clearedImgNm.length > 0) {
            imgPromises.push(
                deleteImgFromCloudAsync({
                    imgsFolder: ImgsFolder.Announcements,
                    useTestFolder: useTestFolder,
                    imgName: clearedImgNm,
                    btnId: '#btnClearImg',
                    divErrMsg: 'divUpdDlgErrMsg'
                })
                    .then(() => clearedImgNm = '')
            )
        }
        if (hasImgsToUpload()) {
            imgPromises.push(uploadImgToCloudAsync({
                imgsFolder: ImgsFolder.Announcements,
                useTestFolder: useTestFolder,
                imgCtrl: '#imgAnnouncement',
                url: 'Storage/Img',
                resizeImage: true,
                useAspectRatio: true,
                divErrMsg: 'divUpdDlgErrMsg',
                postOnload: async (imgNm) => {
                    $('#hiddenImgNm').val(imgNm);
                }
            }));
        }
        await Promise.all(imgPromises).then(async () => {
            await saveDataAsync();
        });
    } else {
        await saveDataAsync();
    }
}

const saveAnnouncementAsync = async (params) => {
    await savePromise({
        url: 'Announcements',
        data: params.data
    });
}

const setUpdateDlgFooter = (params) => {
    if (params.pCode === 0) {
        $('#btnSave').html('Save Draft <span class="fa fa-save"></span>');
        $('#lblScheduled').addClass('hidden');
        $('#btnPublish,#btnScheduleDlg').removeClass('hidden');
    } else {
        $('#btnSave').html('Save <span class="fa fa-save"></span>');
        if (params.dtPublished <= new Date()) {
            $('#btnPublish,#btnScheduleDlg,#lblScheduled').addClass('hidden'); // Announcement is published
        } else {
            $('#lblScheduled').text(`Scheduled ${params.dtPublished.toLocaleDateString()}`);
            $('#btnPublish,#btnScheduleDlg,#lblScheduled').removeClass('hidden'); // Announcement is scheduled
        }
    }
}

let announcement;
let announcementImgsBaseURL = '';
let announcements = [];
let by = "";
let byImgNm = "";
let clearedImgNm = '';
let draftHdr;
let groupImgsBaseURL = '';
let groups = [];
let groupsQueryParam;
let hasComments = true;
let hasGroups = false;
let mg = "";
let publishedHdr;
let scheduledHdr;
let testFolderImgsBaseURL = '';

const initAsync = async () => {

    window.onbeforeunload = (e) => {
        if (isDataModified() === true) {
            return "Your changes have not been saved...";
        }
    };

    setMenu();
    initConfirmDlg();
    initDeleteDlg();
    initScheduleDlg();
    initUpdateDlg();

    by = token.FirstName + ' ' + token.LastName;
    byImgNm = token.ProfileImgNm;
    mg = token.sub;

    const groupsData = await initGroupCtrlsAsync({
        featureID: Features.Announcements,
        useToolBar: true,
        useDDL: true,
        fnToolBarGroupDDLClick: () => {
            const groupID = $('#hiddenToolBarGroupID').val();
            const data = groupID !== '-1' ? announcements.filter(x => x.groupID === parseInt(groupID, 10)) : announcements;
            draftHdr = false;
            scheduledHdr = false;
            publishedHdr = false;
            getTableRows({ arr: data, fnGetRow: getAnnouncementRow, gridNm: 'gridAnnouncements' });
        }
    });

    hasGroups = groupsData.hasGroups;
    groupImgsBaseURL = groupsData.groupImgsBaseURL;
    groups = groupsData.groups;
    groupsQueryParam = groupsData.groupsQueryParam;
    testFolderImgsBaseURL = groupsData.testFolderImgsBaseURL;

    const [announcementsData, imgsBaseURLData, settingsData] = await allSettled({
        promises: [
            getAnnouncementsDataAsync(),
            getImgsBaseURLAsync(ImgsFolder.Announcements, testFolderParam),
            getSettingsAsync()
        ]
    });

    if (announcementsData.status !== 'rejected') {
        announcements = announcementsData.value;
        initAnnouncementsGrid();
        refreshAnnouncementsGrid();
    };
    if (imgsBaseURLData.status !== 'rejected') {
        announcementImgsBaseURL = imgsBaseURLData.value;
    };
    if (settingsData.status !== 'rejected') {
        hasComments = settingsData.value.hasAnnouncementComments;
    };

};

window.snAnnouncements = {
    initAsync
};
